import React, { useCallback, useContext, useEffect, useState } from "react";
import { genericPost } from "../../services/apiServices";
import { GET_DASHBOARD_TOP_RECEIVEABLE } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { Card, CardHeader } from "@mui/material";
import { Box, LinearProgress, Typography } from "@mui/material";
import { t } from "../../constants/translationHelper";
import CustomStatus from "../common/CustomStatus";

function LinearProgressWithLabel({ value }) {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                border: "1px solid #0058CD",
                borderRadius: "8px",
                overflow: "hidden",
            }}
        >
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: 15,
                    backgroundColor: "#FFFFFF",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: "#0058CD",
                    },
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: value > 50 ? "#FFFFFF" : "#0058CD",
                    }}
                >
                    {`${value.toFixed(2)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

const TopReceiveable = () => {
    const [topPayables, setTopCustomers] = useState([]);
    const { token } = useContext(AuthContext);
    const fetchData = useCallback(async () => {
        try {
            const payload = { commanShipmentId: 1 };
            const response = await genericPost(GET_DASHBOARD_TOP_RECEIVEABLE, payload);
            if (response.data.success && response.data.topCustomers) {
                setTopCustomers(response.data.topCustomers);
            }
        } catch (error) {
            console.error("Error fetching Top Payables:", error);
        }
    }, []);

    const totalSum = topPayables.reduce(
        (sum, item) => sum + Number(item.totalAmount || 0),
        0
    );
    const highestBase = totalSum || 0;


    useEffect(() => {
        fetchData();
    }, [fetchData, token]);

    const headerStyle = {
        padding: "10px",
        borderBottom: "2px solid #ddd",
        fontSize: "12px",
        fontWeight: "700",
        color: "#000000",
    }
    return (
        <Card style={{
            padding: "0px", backgroundColor: "#FCF7F7", boxShadow: "none", color: "#000000",

        }}>
            <CardHeader title={t("Top Receivable")}
                titleTypographyProps={{
                    fontWeight: 700,
                    fontSize: "16px"
                }} />
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                }}
            >
                <thead>
                    <tr style={{ background: "#F8EBEBBF", }}>
                        <th style={headerStyle}   >
                            {t("Company Name")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Amount")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Share")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Progress")}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {topPayables.length > 0 ? (
                        topPayables.map((row, index) => {
                            const percentage =
                                highestBase > 0
                                    ? (Number(row.totalAmount) * 100) / highestBase
                                    : 0;
                            const colorIndex = index % colorPlate.length;
                            const rowColor = colorPlate[colorIndex];

                            return (
                                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        {row.customer?.clientCompanyName}

                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        {row.baseCurrency?.currency_symbol}
                                        {parseFloat(row.totalAmount).toLocaleString()}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        <td style={{ padding: "0px" }}>
                                            {highestBase > 0
                                                ? ((Number(row.totalAmount) * 100) / highestBase).toFixed(2) + " %"
                                                : "0 %"}
                                        </td>
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", minWidth: "150px" }}>
                                        <LinearProgressWithLabel
                                            value={percentage}
                                        />
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>
                                {t("No data available")}
                            </td>
                        </tr>
                    )}
                </tbody>

            </table>
        </Card>
    );
};
export default TopReceiveable;

const colorPlate = [
    {
        colorId: 1,
        colorName: "Pebble Sand",
        backgroundColor: "#dfdbd1",
        color: "#13120d"
    },
    {
        colorId: 2,
        colorName: "Sagewood",
        backgroundColor: "#b5c0a8",
        color: "#20251b"
    },
    {
        colorId: 3,
        colorName: "Cherry Blossom",
        backgroundColor: "#FFEEEE",
        color: "#2b0000"
    },
    {
        colorId: 4,
        colorName: "Mint Meadow",
        backgroundColor: "#CFF6CF",
        color: "#072407"
    },
    {
        colorId: 5,
        colorName: "Petal Pink",
        backgroundColor: "#fcddf8",
        color: "#290425"
    },
    {
        colorId: 6,
        colorName: "Periwinkle Glow",
        backgroundColor: "#dcdfff",
        color: "#000532"
    },
    {
        colorId: 7,
        colorName: "Lime Whisper",
        backgroundColor: "#E5F9BD",
        color: "#263605"
    },
    {
        colorId: 8,
        colorName: "Wisteria",
        backgroundColor: "#b985cf",
        color: "#361a42"
    },
    {
        colorId: 9,
        colorName: "POMEGRANATE",
        backgroundColor: "#df786e",
        color: "#75231a"
    },
    {
        colorId: 10,
        colorName: "Peter river",
        backgroundColor: "#6eb6e5",
        color: "#13496d"
    }
];
